/**
 * THE PRODUCT'S NAME AND MARK — the Pro Hub half of TENEAN B.7 (Peter, 2026-09-21: "Everything
 * becomes Tenean"; decisions da1e9f57 · ed2ada36 · 4c141eb8). The Pro Hub is a sibling of the
 * Owner Hub and wears the same identity: the product is Tenean, IMAGE Studios is a location.
 *
 * ONE PLACE for the name, so a rename is one edit and a guard can refuse a regrown literal.
 */
export const PRODUCT_NAME = 'Tenean';
export const PRODUCT_TAGLINE = 'Salon Operating System';
/** "Money · Tenean" in a tab; "Tenean — Pro Hub" on its own. */
export const documentTitle = (page?: string): string => (page ? `${page} · ${PRODUCT_NAME}` : `${PRODUCT_NAME} — Pro Hub`);
